import EditIcon from '@mui/icons-material/Edit'
import styled, { css } from 'styled-components'

export const ContainerEdit = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.layout.gap.small};
    cursor: pointer;
    text-transform: uppercase;

    span {
      font-size: ${theme.typograph.fontsize.h3};
      color: ${theme.colors.primary.main};

      @media (max-width: ${theme.screen.medium}) {
        display: none;
      }
    }
  `
)

export const Edit = styled(EditIcon)(
  ({ theme }) => css`
    font-size: ${theme.layout.iconSize.big};
    width: ${theme.layout.iconSize.big};
    height: ${theme.layout.iconSize.big};
    color: ${theme.colors.primary.main};
  `
)
